<template>
  <div class="layer_section-container" v-if="orderInfo.group_order_yn != 'Y'">
    <div class="layer-header">
      <h1 class="header-title">
        주문취소 방법 선택
      </h1>
    </div>
    <div class="layer-content">
      <div class="pop-orderCancel-area">
        <p class="tit">
          주문취소 내역
        </p>

        <div class="myorder-list">
          <div class="list-content">
            <div class="list-row-title row">
              <div class="col-ak-10 can-num">
                주문번호
              </div>
              <div class="col-ak-10 can-date">
                주문일자
              </div>
              <div class="col-ak-10 can-price">
                결제금액(원)
              </div>
              <div class="col-ak-10 can-pvbv">
                총 PV/BV
              </div>
            </div>
            <div class="content-list">
              <div class="row con-list-item">
                <div class="col-ak-10 can-num">
                  <span class="tite-label">주문번호</span>
                  <span class="txte-wrap"><a
                    @click.prevent="onClickPaymentInfo(orderInfo.order_key)"
                  >{{ orderInfo.order_key }}</a></span>
                </div>
                <div class="col-ak-10 can-date">
                  <span class="tite-label">주문일자</span>
                  <span class="txte-wrap">{{ orderInfo.order_date }}</span>
                </div>
                <div class="col-ak-10 can-price">
                  <span class="tite-label">결제금액</span>
                  <span class="txte-wrap">
                    <mpn-label-number :amount="price" />
                  </span>
                </div>
                <div class="col-ak-10 can-pvbv">
                  <span class="tite-label">총 PV/BV</span>
                  <span class="txte-wrap"><mpn-label-number :amount="pv" />
                    /
                    <mpn-label-number :amount="bv" /></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="align-box size-auto">
      <button
        type="button"
        class="btn-modal_confirm"
        @click="onDispose"
      >
        취소
      </button>
      <button
        type="button"
        class="btn-modal_close v2"
        @click="onOk"
      >
        확인
      </button>
    </div>
    <modal-confirm
      ref="refModal"
      text="주문을 취소하시겠습니까?"
      @confirm="onFinalConfirm"
      @cancel="onFinalCancel"
    />
  </div>
  <!-- (팝업) 210121 일괄 주문취소  -->
  <div class="layer_section-container" v-else>
    <div class="layer-header">
      <h1 class="header-title">
        <p>주문 내역이 일괄 취소됩니다.</p>
        <p>취소하시겠습니까?</p>
      </h1>
    </div>
    <div class="layer-content total_order_cancel">
      <div class="pop-orderCancel-area" v-for="order in orderInfo.group_order_list" :key="order.order_key">
        <p class="tit">{{ order.mypack_name }}</p>
        <div class="myorder-list">
          <div class="list-content">
            <div class="list-row-title row">
              <div class="col-ak-10 can-num">주문번호</div>
              <div class="col-ak-10 can-date">주문일자</div>
              <div class="col-ak-10 can-price">결제금액(원)</div>
              <div class="col-ak-10 can-pvbv">총 PV/BV</div>
            </div>
            <div class="content-list">
              <div class="row con-list-item">
                <div class="col-ak-10 can-num">
                  <span class="tite-label">주문번호</span>
                  <span class="txte-wrap"><a
                    @click.prevent="onClickPaymentInfo(order.order_key)"
                  >{{ order.order_key }}</a></span>
                </div>
                <div class="col-ak-10 can-date">
                  <span class="tite-label">주문일자</span>
                  <span class="txte-wrap">{{ orderInfo.order_date }}</span>
                </div>
                <div class="col-ak-10 can-price">
                  <span class="tite-label">결제금액</span>
                  <span class="txte-wrap">
                    <mpn-label-number :amount="order.total_price" />
                  </span>
                </div>
                <div class="col-ak-10 can-pvbv">
                  <span class="tite-label">총 PV/BV</span>
                  <span class="txte-wrap"><mpn-label-number :amount="order.total_pv" />
                    /
                    <mpn-label-number :amount="order.total_bv" /></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="align-box size-auto">
      <button
        type="button"
        class="btn-modal_confirm"
        @click="onDispose"
      >
        취소
      </button>
      <button
        type="button"
        class="btn-modal_close v2"
        @click="onOk"
      >
        확인
      </button>
    </div>
    <modal-confirm
      ref="refModal"
      text="주문을 취소하시겠습니까?"
      @confirm="onFinalConfirm"
      @cancel="onFinalCancel"
    />
  </div>
<!-- //(팝업) 210121 일괄 주문취소 -->
</template>
<script>
import { log, openNewWindow } from '@/utils/common';
import { mapGetters } from 'vuex';
import ModalConfirm from '@/components/global/ModalConfirm.vue';

export default {
  name: 'PopupCancelOrder',
  components: {
    ModalConfirm,
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {},
    },
    selectedPackCd: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters({
      userId: 'userId',
    }),
    price() {
      return parseInt(this.orderInfo.order_total_price, 10);
    },
    pv() {
      return parseInt(this.orderInfo.order_total_pv, 10);
    },
    bv() {
      return parseInt(this.orderInfo.order_total_bv, 10);
    },
  },
  created() {
    log('PopupCancelOrder::created', 'created');
  },
  mounted() {
    log('PopupCancelOrder::mounted', 'mounted');
  },
  beforeDestroy() {
    log('PopupCancelOrder::beforeDestroy', 'beforeDestroy');
  },
  destroyed() {
    log('PopupCancelOrder::destroyed', 'destroyed');
  },
  methods: {
    onDispose() {
      log('PopupCancelOrder::onDispose', 'click-dispose');
      this.$emit('dispose', 'get out!');
    },
    onOk() {
      this.$refs.refModal.open();
    },
    onFinalConfirm() {
      log('PopupCancelOrder::onFinalConfirm', 'confirm finally');
      this.$emit('confirm');
    },
    onFinalCancel() {

    },
    onClickPaymentInfo(orderKey) {
      openNewWindow(`https://${process.env.SSO_HOST}/my-account/orders/${orderKey}`, 'store-finder');
    },
  },
};
</script>
